/* Breakz — Google Ads, loaded only after consent.
 *
 * Client request of 07.09.2026, verbatim: "Same as GA4 — gate all of
 * this behind the cookie consent banner rather than firing immediately».
 * That is exactly what happens here, and it is what ekomlov § 3-15
 * requires: consent BEFORE the request to a third party, not
 *
 * anonymisation after it. So `gtag.js` is not in the markup. Not a byte
 * goes to googletagmanager.com until someone allows the
 * "Markedsføring" category. Consent Mode is the second layer here, not
 * the first: with storage denied the script still calls Google, and
 * Norwegian law forbids the call itself — noted in `breakz-shopify-facts`.
 *
 * Withdrawing consent after loading can no longer unload the script, but
 * it can put Consent Mode into denied — which is what happens.
 */

(function () {
  'use strict';

  var root = document.querySelector('[data-bx-ads]');
  if (!root) return;

  var ID = root.getAttribute('data-bx-ads-id') || '';
  var CONVERSION = root.getAttribute('data-bx-ads-conversion') || '';
  var TRIGGER = root.getAttribute('data-bx-ads-trigger') || 'success';
  /* The markup already carries the tag, so this file must not fetch it
     again — two copies of gtag.js for one id double-count. */
  var INLINE = root.getAttribute('data-bx-ads-inline') === 'true';
  if (!ID) return;

  var loaded = INLINE;

  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }
  window.gtag = window.gtag || gtag;

  function allowed() {
    return !!(window.BreakzConsent && window.BreakzConsent.allows('marketing'));
  }

  function boot() {
    if (loaded) {
      /* Inline mode: the tag is already running. Consent still has to be
         passed on, and the conversion still has to be considered. */
      grant();
      fireIfDue();
      return;
    }
    loaded = true;

    /* The order matters: `consent default` has to reach dataLayer before
       `js` and before the script itself, otherwise Google treats the
       state as undefined. */
    gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied'
    });
    gtag('js', new Date());
    gtag('config', ID);
    grant();

    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ID);
    document.head.appendChild(s);

    fireIfDue();
  }

  function grant() {
    gtag('consent', 'update', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted'
    });
  }

  function revoke() {
    if (!loaded) return;
    gtag('consent', 'update', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
  }

  /* Conversion. Sent once per success page: the URL after a signup
     carries `customer_posted=true`, and reloading that page must not
     count a second time. */
  var SENT_KEY = 'breakz.ads.conversion';

  function sentMark() {
    return location.pathname + location.search;
  }

  function alreadySent() {
    try {
      return sessionStorage.getItem(SENT_KEY) === sentMark();
    } catch (e) {
      return false;
    }
  }

  function markSent() {
    try {
      sessionStorage.setItem(SENT_KEY, sentMark());
    } catch (e) {}
  }

  function conversion() {
    if (!CONVERSION || !loaded || !allowed() || alreadySent()) return false;
    markSent();
    window.gtag('event', 'conversion', { send_to: CONVERSION });
    return true;
  }

  window.breakzAdsConversion = conversion;

  /* What counts as a conversion.
   *
   * `success` — a confirmed signup: Shopify returns the person to a page
   * where Liquid rendered `.pw-note--ok` from the
   * `form.posted_successfully?` branch. This is the default.
   *
   * `submit` — the button press, as in the marketer's original snippet.
   * It counts typos in the email, repeat presses and submissions Shopify
   * rejected. Kept as a setting in case the numbers have to match
   * something on their side.
   */
  /* Success is read from two independent signals, and either is enough.
     The client's marketing side proposed the URL check on 07.09.2026:
     `customer_posted=true`, the parameter Shopify redirects back with.
     We already shipped the DOM check that morning — `.pw-note--ok`, the
     element Liquid renders inside the `form.posted_successfully?` branch.

     Both describe the same state, so we take both rather than choose.
     Neither is more truthful than the other — Liquid opens the success
     branch on that very parameter, verified by loading the address by
     hand. What they differ in is what breaks them: the parameter dies if
     Shopify renames it, the element dies if the markup is edited. Two
     readings survive either. Double counting is not a risk: the guard
     above fires once per address. */
  function fireIfDue() {
    if (TRIGGER !== 'success') return;

    var byUrl = location.search.indexOf('customer_posted=true') > -1;
    var byMarkup = !!document.querySelector('.pw-note--ok');

    if (byUrl || byMarkup) conversion();
  }

  if (TRIGGER === 'submit') {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.querySelector || !form.querySelector('.pw-submit')) return;
      /* The form goes out as a normal POST; we do not delay navigation:
         gtag sends the event through sendBeacon, which survives leaving
         the page. Waiting for a callback would cost the person a visible
         pause on the button for the sake of a line in a report. */
      conversion();
    }, true);
  }

  /* The listener is attached ALWAYS, not only when consent is missing.
     Otherwise someone who allowed marketing and changed their mind on the
     same page would be left with Ads running: the withdrawal branch would
     simply not be subscribed. */
  document.addEventListener('breakz:consent', function (event) {
    var d = event.detail || {};
    if (d.marketing) boot();
    else revoke();
  });

  /* Consent given on an earlier visit fires no event — it is served by
     `BreakzConsent.allows`. So we also check directly.
     This only works if this script comes AFTER `breakz-consent.js`:
     both are deferred, so they run in document order. */
  if (allowed()) boot();
})();
